import { render, staticRenderFns } from "./payments_section.vue?vue&type=template&id=d65a3c70&"
import script from "./payments_section.vue?vue&type=script&lang=js&"
export * from "./payments_section.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports